import {
  CHANGE_CURRENT_SEARCH_VALUE,
  CHANGE_DEBOUNCED_SEARCH_VALUE,
  RESET_SEARCH_VALUE,
} from '../actions';

const initialState = {
  debouncedSearchValue: '',
  currentSearchValue: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_CURRENT_SEARCH_VALUE:
      return { ...state, currentSearchValue: action.payload };

    case CHANGE_DEBOUNCED_SEARCH_VALUE:
      return { ...state, debouncedSearchValue: action.payload };

    case RESET_SEARCH_VALUE:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
